import { useAtom } from "jotai";
import React from "react";
import { MenuItem } from "../components/Menu";
import { currentSpaceAtom } from "../jotai/atoms";
import { useSpaceInfo } from "../liveblocks/maps";
import { upload } from "../utils/fileUpload";

async function digestMessage(message: string) {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(""); // convert bytes to hex string
  return hashHex;
}

export default function ExportWebpage() {
  const [info] = useSpaceInfo();
  const [currentSpace] = useAtom(currentSpaceAtom);

  const exportPage = async () => {
    if (!currentSpace) {
      return;
    }

    const stichesStyles = Array.from(document.styleSheets)
      .map((sheet) => {
        let cssRules: CSSRuleList;
        try {
          /**
           * May throw:
           * DOMException: Failed to read the 'cssRules' property from 'CSSStyleSheet': Cannot access rules
           */
          cssRules = sheet.cssRules;
        } catch (error) {
          return "";
        }

        return Array.from(cssRules)
          .map((r) => r.cssText)
          .join("\n");
      })
      .join("\n");

    const styleOverrides = `
      nav {display:none !important;}
      .minimap {display:none !important;}
      main, .background {cursor:pointer !important;}
      radix-portal { display: none; }
      .cursor { display: none; }
      `;
    const styleNode = document.createElement("style");
    styleNode.innerHTML = styleOverrides + stichesStyles;

    document.head.appendChild(styleNode);

    let html = (document?.body?.parentNode as Element).outerHTML;
    styleNode.remove();

    html = html.replaceAll(/<script/g, "<noscript");
    html = html.replaceAll(/\/script>/g, "/noscript>");
    html = html.replaceAll(currentSpace.id, "[id]");

    const hash = await digestMessage(currentSpace.id);
    const filename = `${(info?.name || "") + hash}`;
    const key = `pages/${filename}.html`;
    const blob = new Blob([html], { type: "text/html" });

    const tab = window.open("about:blank");
    if (tab) {
      upload(blob, key)
        .then((url) => {
          tab.location = url;
          tab.focus();
        })
        .catch(() => {});
    }
  };
  return (
    <MenuItem
      onSelect={() => {
        // let menu finish closing before we snapshot
        window.setTimeout(exportPage, 10);
      }}
    >
      Publish space to webpage
    </MenuItem>
  );
}
